// Exclusion de motorisations dans les critères de recherche leads-vo.
// Contrat partenaire (10/09/2026) : `criteres_vehicule.motorisations_exclues` est un
// tableau de texte libre, 8 entrées max de 40 caractères, valeur attendue « PureTech ».

export const PURETECH = 'PureTech';
const MAX_ENTRIES = 8;

const isPuretech = (value: string): boolean => value.trim().toLowerCase() === PURETECH.toLowerCase();

export const hasPuretechExcluded = (motorisations: string[] | null | undefined): boolean =>
  (motorisations ?? []).some(isPuretech);

// Ajoute ou retire PureTech sans toucher aux autres entrées éventuelles.
export const togglePuretechExclusion = (motorisations: string[] | null | undefined, excluded: boolean): string[] => {
  const current = motorisations ?? [];
  if (!excluded) return current.filter((value) => !isPuretech(value));
  if (hasPuretechExcluded(current)) return current;
  if (current.length >= MAX_ENTRIES) return current;
  return [...current, PURETECH];
};
